import axios from 'axios'
import { call, cancelled, put, takeLatest } from 'typed-redux-saga'
import { createAsyncAction } from 'typesafe-actions'
import {
  getAccountLinkingRequest,
  IAccountLinkingRequest
} from '../../../../../api/dynamics'
import { AppState } from '../../../../../store'
import {
  createAsyncReducer,
  createAsyncSelectors
} from '../../../../../store/shared/asyncStore'
import { getDynamicsApiOptions } from '../../../../../store/shared/sagas'

export const accountLinkingRequestFetchActions = createAsyncAction(
  '@features/@accountLinking/@features/@accountLinkingRequestView/@accountLinkingRequestFetch/REQUEST',
  '@features/@accountLinking/@features/@accountLinkingRequestView/@accountLinkingRequestFetch/SUCCESS',
  '@features/@accountLinking/@features/@accountLinkingRequestView/@accountLinkingRequestFetch/FAILURE'
)<string, IAccountLinkingRequest, Error>()

export const accountLinkingRequestFetchReducer = createAsyncReducer(
  accountLinkingRequestFetchActions
)

const rootSelector = (state: AppState) =>
  state.features.accountLinking.features.accountLinkingRequestView
    .accountLinkingRequestFetch

export const {
  getError: getAccountLinkingRequestFetchError,
  getIsLoading: getIsAccountLinkingRequestFetchLoading,
  getResult: getAccountLinkingRequestFetchResult
} = createAsyncSelectors(rootSelector)

const onRequest = function* (
  action: ReturnType<typeof accountLinkingRequestFetchActions.request>
) {
  // eslint-disable-next-line import/no-named-as-default-member
  const source = axios.CancelToken.source()

  try {
    const apiOptions = yield* call(getDynamicsApiOptions)

    const result = yield* call(
      getAccountLinkingRequest,
      apiOptions,
      action.payload
    )

    yield put(accountLinkingRequestFetchActions.success(result))
  } catch (e: unknown) {
    yield put(accountLinkingRequestFetchActions.failure(e as Error))
  } finally {
    if (yield* cancelled()) {
      source.cancel()
    }
  }
}

export const accountLinkingRequestFetchSagas = [
  () => takeLatest(accountLinkingRequestFetchActions.request, onRequest)
]
